import { EntityDefinition } from '@/types/crud';

// User entity configuration - Updated to fix export issues
export const userEntity: EntityDefinition = {
  name: 'users',
  displayName: 'Users',
  displayNameSingular: 'User',
  apiEndpoint: '/users/admin/users',
  routePath: 'user-management',
  idField: 'id',
  nameField: 'email',
  
  fields: [
    {
      key: 'email',
      label: 'userManagement.email',
      type: 'email',
      required: true,
      placeholder: 'userManagement.enterEmailAddress',
      readOnly: true
    },
    {
      key: 'first_name',
      label: 'userManagement.firstName',
      type: 'text',
      required: true,
      placeholder: 'userManagement.enterFirstName'
    },
    {
      key: 'last_name',
      label: 'userManagement.lastName',
      type: 'text',
      required: true,
      placeholder: 'userManagement.enterLastName'
    },
    {
      key: 'status',
      label: 'userManagement.status',
      type: 'select',
      required: false,
      options: [
        { value: 'ACTIVE', label: 'userManagement.statusActive' },
        { value: 'INACTIVE', label: 'userManagement.statusInactive' },
        { value: 'PENDING', label: 'userManagement.statusPending' }
      ]
    },
    {
      key: 'tenant_name',
      label: 'userManagement.tenant',
      type: 'text',
      required: false,
      readOnly: true
    },
    {
      key: 'is_tenant_admin',
      label: 'userManagement.tenantAdmin',
      type: 'checkbox',
      required: false,
      description: 'userManagement.tenantAdminDescription'
    },
    {
      key: 'business_hierarchy_id',
      label: 'userManagement.businessHierarchy',
      type: 'select',
      required: false,
      options: [],
      description: 'userManagement.businessHierarchyDescription'
    },
    {
      key: 'functional_hierarchy_id',
      label: 'userManagement.functionalHierarchy',
      type: 'select',
      required: false,
      options: [],
      description: 'userManagement.functionalHierarchyDescription'
    },
    {
      key: 'geographic_hierarchy_id',
      label: 'userManagement.geographicHierarchy',
      type: 'select',
      required: false,
      options: [],
      description: 'userManagement.geographicHierarchyDescription'
    }
  ],

  tableColumns: [
    {
      key: 'email',
      label: 'userManagement.email',
      sortable: true,
      width: '25%'
    },
    {
      key: 'name',
      label: 'userManagement.name',
      sortable: true,
      width: '20%',
      render: (_value: any, row: any) => {
        const first = row.first_name || '';
        const last = row.last_name || '';
        return `${first} ${last}`.trim() || '—';
      }
    },
    {
      key: 'status',
      label: 'userManagement.status',
      sortable: true,
      width: '10%',
      render: (value: string) => {
        const getStatusColor = (status: string) => {
          switch (status) {
            case 'ACTIVE': return 'bg-green-100 text-green-800';
            case 'INACTIVE': return 'bg-gray-100 text-gray-800';
            case 'PENDING': return 'bg-yellow-100 text-yellow-800';
            default: return 'bg-gray-100 text-gray-800';
          }
        };
        return `<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(value)}">${value}</span><br>`;
      }
    },
    {
      key: 'tenant_name',
      label: 'userManagement.tenant',
      sortable: true,
      width: '20%'
    },
    {
      key: 'roles',
      label: 'userManagement.roles',
      sortable: false,
      width: '20%',
      render: (_value: any, row: any) => {
        const roles = row.roles ?? row.role_names;
        if (Array.isArray(roles)) {
          return roles.length ? roles.join(', ') : '—';
        }
        if (typeof roles === 'string') {
          return roles || '—';
        }
        return '—';
      }
    },
    {
      key: 'subscription',
      label: 'userManagement.subscription',
      sortable: false,
      width: '20%',
      render: (_value: any, row: any) => {
        const planName =
          row.billing_summary?.activeOrPendingSubscription?.plan_name ||
          row.active_subscription_plan_name ||
          null;
        return planName || '—';
      }
    },
    {
      key: 'is_tenant_admin',
      label: 'userManagement.tenantAdmin',
      sortable: true,
      width: '10%',
      render: (value: boolean) => value ? 'Yes' : 'No'
    }
  ],

  searchFields: ['email', 'first_name', 'last_name', 'tenant_name'],
  
  defaultSort: {
    field: 'email',
    direction: 'asc'
  },

  permissions: {
    create: 'user.management.create',
    read: 'user.management.read',
    update: 'user.management.update',
    delete: 'user.management.delete'
  },

  // Custom actions for user management
  customActions: [
    {
      key: 'resetPassword',
      name: 'resetPassword',
      label: 'Reset Password',
      icon: 'KeyIcon',
      action: 'custom',
      onClick: () => {} // Placeholder - will be handled by component
    },
    {
      key: 'viewProfile',
      name: 'viewProfile',
      label: 'View Profile',
      icon: 'EyeIcon',
      action: 'view',
      onClick: () => {} // Placeholder - will be handled by component
    }
  ],

  // Form validation rules
  validation: {
    email: {
      required: 'Email is required',
      email: 'Please enter a valid email address'
    },
    first_name: {
      required: 'First name is required',
      minLength: {
        value: 2,
        message: 'First name must be at least 2 characters'
      }
    },
    last_name: {
      required: 'Last name is required',
      minLength: {
        value: 2,
        message: 'Last name must be at least 2 characters'
      }
    }
  }
};
